import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Card from '@components/Card/Card';
import Button from '@components/CustomButton';
import { nextAppPage } from '@modules/nav';
import { globalActions } from '@reducers/global';
import { userActions } from '@reducers/user';
import withRouter from '@wrappers/withRouter';

const PersonalInformationParent = props => {
	const { navigate, location } = props,
		dispatch = useDispatch(),
		app_id = useSelector(state => state.user.app_id),
		app = useSelector(state => state.user.apps[app_id]?.json_obj),
		setSubmenu = val => dispatch(userActions.setSubmenus({ key: 'personal_info_open', val })),
		captureError = ex => dispatch(globalActions.captureError(ex));

	useEffect(() => {
		setSubmenu(true);
	}, []);

	function onSubmit(e) {
		try {
			e.preventDefault();
			e.stopPropagation();

			navigate(nextAppPage(app, location.pathname));
		} catch (ex) {
			captureError(ex);
		}
	}

	function onBack(e) {
		try {
			setSubmenu(false);
			navigate('/summary');
		} catch (ex) {
			captureError(ex);
		}
	}

	if (!app_id) return null;

	return (
		<Card
			title='PERSONAL INFORMATION'
			content={
				<form id='form' onSubmit={onSubmit}>
					<p>
						You will be asked to provide information about yourself, your background, and your
						parent(s)/guardian(s).
					</p>

					<div className='clearfix' />
				</form>
			}
			buttons={
				<>
					<Button variant='info' className='back-btn' fill onClick={onBack}>
						Back
					</Button>
					<Button form='form' autoFocus variant='info' className='save-btn' fill type='submit'>
						Continue
					</Button>
				</>
			}
		/>
	);
};

export default withRouter(PersonalInformationParent);
